// Currently, we have only two levels, essential and non essential. In future,
// we may go more granular and split non-essential to different groups, ie.
// analytics, advertising, performance and such
export const consents = ['essential', 'non-essential'];
